import { SESSION_EXPIRED_MESSAGE } from "constants/apiErrorMessages";

let sessionAuthErrorMessage = null;
const subscribers = new Set();

const notifySubscribers = () => {
  subscribers.forEach((callback) => {
    callback(sessionAuthErrorMessage);
  });
};

export const subscribeSessionAuthError = (callback) => {
  subscribers.add(callback);
  callback(sessionAuthErrorMessage);

  return () => {
    subscribers.delete(callback);
  };
};

export const getSessionAuthErrorMessage = () => sessionAuthErrorMessage;

export const clearSessionAuthError = () => {
  sessionAuthErrorMessage = null;
  notifySubscribers();
};

export const notifySessionExpired = (message) => {
  const nextMessage = message || SESSION_EXPIRED_MESSAGE;

  if (sessionAuthErrorMessage === nextMessage) {
    return;
  }

  sessionAuthErrorMessage = nextMessage;
  notifySubscribers();
};
